<template>
  <div class="content">
    <div>
      <div class="md-layout-item md-size-100 text-right">
        <div v-if="errors">
          <span v-for="error in errors" class="text-danger">{{error[0]}}</span>
        </div>
        <md-chip
            v-if="hasAnyErrors"
            class="md-accent mt-3"
            md-dense
        >
          {{ totalErrorCount }} error{{ totalErrorCount !== 1 ? 's' : '' }}
        </md-chip>
        <md-button class="md-raised md-success mx-3" @click="saveData(1)">Save</md-button>
        <md-button class="md-raised md-success" @click="saveData(0)">
          Publish
        </md-button>
      </div>
    </div>
    <div>
      <nav-tabs-card>
        <template slot="content">
          <md-tabs class="md-success navigate_bar" md-alignment="left" ref="tabs">
            <md-tab
                id="tab-home"
                md-icon="contacts"
                md-label="Basic Info"
                :class="{ 'has-error': hasBasicInfoErrors }"
                :title="hasBasicInfoErrors ? getTabErrorMessage('basic-info') : ''"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>
                      Basic info
                      <md-chip
                          v-if="hasBasicInfoErrors"
                          class="md-accent error-chip"
                          md-dense
                      >
                        {{ basicInfoErrorCount }} error{{ basicInfoErrorCount !== 1 ? 's' : '' }}
                      </md-chip>
                    </h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{'md-invalid': showErrors && !basic_info.external_listing_name}">
                              <label>External Listing Name*</label>
                              <md-input v-model="basic_info.external_listing_name" placeholder="Name*"></md-input>
                              <span class="md-error" v-if="showErrors && !basic_info.external_listing_name">
                                External Listing Name is required
                              </span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Person capacity</label>
                              <md-select v-model="basic_info.person_capacity" name="person_capacity" id="person_capacity">
                                <md-option :value="''" disabled>Select capacity</md-option>
                                <md-option
                                    v-for="item in personCapacities"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>

                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Tags</label>
                              <md-select
                                  v-if="Array.isArray(basic_info.tags_ids)"
                                  md-multiple
                                  name="tags"
                                  id="tags"
                                  @md-selected="onTagSelected"
                              >
                                <md-option
                                    v-for="tag in tagOptions"
                                    :key="tag.id"
                                    :value="tag.id"
                                    :disabled="basic_info.tags_ids.includes(tag.id)"
                                >
                                  {{ tag.name }}
                                </md-option>
                                <md-option v-if="tagOptions.length === 0" disabled>
                                  No tags found
                                </md-option>
                              </md-select>
                            </md-field>

                            <div v-if="hasSelectedTags" class="selected-tags mt-2">
                              <md-chip
                                  v-for="tagId in basic_info.tags_ids"
                                  :key="tagId"
                                  md-deletable
                                  @md-delete="removeTag(tagId)"
                                  class="mr-1 mb-1"
                              >
                                {{ getTagName(tagId) }}
                              </md-chip>
                            </div>

                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Property type</label>
                              <md-select v-model="basic_info.property_type_id" name="property_type" id="property_type">
                                <md-option :value="''" disabled>Select type</md-option>
                                <md-option
                                    v-for="item in propertyTypes"
                                    :key="item.id"
                                    :value="item.id">
                                  {{ item.name }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field maxlength="6">
                              <label>Description</label>
                              <md-textarea v-model="basic_info.description" placeholder="Description"></md-textarea>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Room type</label>
                              <md-select v-model="basic_info.room_type_id" name="room_type" id="room_type">
                                <md-option
                                    v-for="item in roomTypes"
                                    :key="item.id"
                                    :value="item.id">
                                  {{ item.name }}
                                </md-option>
                              </md-select>
                            </md-field>
                            <md-field>
                              <label>Number of bedrooms</label>
                              <md-select v-model="basic_info.number_of_bedrooms" name="number_of_bedrooms" id="number_of_bedrooms">
                                <md-option
                                    v-for="item in numberOfBedrooms"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Number of beds</label>
                              <md-select v-model="basic_info.number_of_beds" name="number_of_beds" id="number_of_beds">
                                <md-option
                                    v-for="item in numberOfBeds"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                            <md-field>
                              <label>Number of bathrooms</label>
                              <md-select v-model="basic_info.number_of_bathrooms" name="number_of_bathrooms" id="number_of_bathrooms">
                                <md-option
                                    v-for="item in numberOfBathrooms"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                            <md-field>
                              <label>Bathroom type</label>
                              <md-select v-model="basic_info.bathroom_type_id" name="bathroom_type" id="bathroom_type">
                                <md-option
                                    v-for="item in bathroomTypes"
                                    :key="item.id"
                                    :value="item.id">
                                  {{ item.name }}
                                </md-option>
                              </md-select>
                            </md-field>
                            <md-field>
                              <label>Number of guest bathrooms</label>
                              <md-select v-model="basic_info.number_of_guest_bathrooms" name="number_of_guest_bathrooms" id="number_of_guest_bathrooms">
                                <md-option
                                    v-for="item in numberOfGuestBathrooms"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <!--                <div class="md-layout-item md-size-100 text-right">-->
                          <!--                  <md-button class="md-raised md-success">Update Profile</md-button>-->
                          <!--                </div>-->
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="address"
                md-label="Address"
                md-icon="place"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Address</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <div>
                              <l-map
                                  v-if="lat && lng"
                                  :zoom="16"
                                  :center="[lat, lng]"
                                  style="height: 500px; width: 100%"
                                  :options="{ attributionControl: false }"
                              >
                                <l-tile-layer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                ></l-tile-layer>

                                <l-marker :lat-lng="[lat, lng]">
                                  <l-popup>{{ setAddress }}</l-popup>
                                </l-marker>
                              </l-map>
                              <div v-else style="height: 500px; width: 100%; display: flex; align-items: center; justify-content: center; background: #f0f0f0;">
                                <p>Loading map or no coordinates available...</p>
                              </div>
                            </div>

<!--                            <Maps/>-->
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Address</label>
                              <md-input v-model="address.address" md-placeholder="Address" @input="checkMap"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>Public address</label>
                              <md-input v-model="address.public_address" md-placeholder="Public Address"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>Country</label>
                              <md-input v-model="address.country" md-placeholder="Country" @input="checkMap"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>State</label>
                              <md-input v-model="address.state" md-placeholder="State" @input="checkMap"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>City</label>
                              <md-input v-model="address.city" md-placeholder="City" @input="checkMap"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>Street</label>
                              <md-input v-model="address.street" md-placeholder="Street"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>Zip code / Postcode</label>
                              <md-input v-model="address.zip_code" md-placeholder="Zip code"></md-input>
                            </md-field>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="media"
                md-label="Media"
                md-icon="camera"
                class="h-auto"
            >
              <div class="media_tab">
                <div class="title">
                  <h4>Media</h4>
                  <div
                      class="dropzone_container"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                      :style="isDragging && 'border-color: green;'"
                  >
                    <input
                        type="file"
                        multiple
                        name="file"
                        id="fileInput"
                        class="dropzone_input"
                        @change="onChange"
                        ref="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                    />
                    <label for="fileInput" class="dropzone_label">
                      <div v-if="isDragging">Release to drop files here.</div>
                      <div v-else>Drop files here or <u>click here</u> to upload.</div>
                      <p>Minimum size requirement for photos: 1024 x 683 pixels</p>
                    </label>
                  </div>
                </div>
                <div class="media_main">

                  <div class="preview_container mr-1" v-if="files.length">
                    <div v-for="file in files" :key="file.name" class="preview_card">
                      <div class="preview_card-item">
                        <img class="preview_img" :alt="file.name"  :src="generateURL(file)"  />
                        <p>
                          <!--                          {{ file.name }} - {{ Math.round(file.size / 1000) + "kb" }}-->
                        </p>
                        <div class="preview_card_input-item md-layout-item md-small-size-100 md-size-100">
                          <md-field md-dense>
                            <label>Airbnb caption</label>
                            <md-input v-model="file.image_sequences" md-placeholder="Airbnb caption"></md-input>
                          </md-field>
                        </div>
                        <div class="preview_card_input-item md-layout-item md-small-size-100 md-size-100">
                          <md-field md-dense>
                            <label>Vrbo caption</label>
                            <md-input v-model="file.vrbo_caption" md-placeholder="Vrbo caption"></md-input>
                          </md-field>
                        </div>
                        <div class="preview_card_input-item md-layout-item md-small-size-100 md-size-100">
                          <md-field md-dense>
                            <label>Booking Engine caption</label>
                            <md-input v-model="file.engine_caption" md-placeholder="Booking Engine caption"></md-input>
                          </md-field>
                        </div>
                      </div>
                      <button
                          class="preview_card-close ml-2"
                          type="button"
                          @click="remove(files.indexOf(file))"
                          title="Remove file"
                      >
                        ×
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </md-tab>
            <md-tab id="home" md-label="Amenities" md-icon="home">
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Amenities</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout md-gutter flex-column">
                          <div
                              class="md-layout-item md-small-size-100 md-size-50"
                              v-for="(amenity, index) in amenities"
                              :key="index"
                          >
                            <md-checkbox
                                v-model="amenity.checked"
                                class="md-primary m-1"
                            >
                              {{ amenity.name }}
                            </md-checkbox>
                          </div>
                        </div>
<!--                        <div class="">-->
<!--                          <md-table v-model="amenities" @md-selected="onSelect">-->
<!--                            <md-table-row-->
<!--                                slot="md-table-row"-->
<!--                                slot-scope="{ item }"-->
<!--                                md-selectable="multiple"-->
<!--                                md-auto-select-->
<!--                            >-->
<!--                              <md-table-cell>{{ item.name }}</md-table-cell>-->
<!--                            </md-table-row>-->
<!--                          </md-table>-->
<!--                        </div>-->
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="price"
                md-label="Price & fees"
                md-icon="money"
            >
             <div class="md-layout">
               <div class="md-layout-item md-medium-size-100 md-size-100">
                 <div class="title">
                   <h4>Price & fees</h4>
                 </div>
                 <form>
                   <md-card>
                     <md-card-content>
                       <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                             <v-select
                                 v-model="price_and_fees.currency_code"
                                 :options="currencyOptions"
                                 label="code"
                                 :reduce="currency => currency.code"
                                 placeholder="Type or select currency"
                                 class="currency_code"
                             />
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Price</label>
                             <md-input v-model="price_and_fees.price" type="number" placeholder="Price"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Price for extra person</label>
                             <md-input v-model="price_and_fees.price_fo_extra_person" type="number" placeholder="Price for extra person"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Guests included</label>
                             <md-input v-model="price_and_fees.guests_included" type="number" placeholder="Guests included"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Refundable damage deposit fee</label>
                             <md-input v-model="price_and_fees.refundable_damage_deposit" type="number" placeholder="Refundable damage deposit fee"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Cleaning fee</label>
                             <md-input v-model="price_and_fees.cleaning_fee" type="number" placeholder="Cleaning fee"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Weekly discount</label>
                             <md-input v-model="price_and_fees.weekly_discount" type="number" placeholder="Weekly discount"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Monthly discount</label>
                             <md-input v-model="price_and_fees.monthly_discount" type="number" placeholder="Monthly discount"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-100">
                           <md-table v-model="exclude_from_reservation" @md-selected="onSelectReservation">
                             <md-table-row
                                 slot="md-table-row"
                                 slot-scope="{ item }"
                                 md-selectable="multiple"
                                 md-auto-select
                             >
                               <md-table-cell>{{ item.name }}</md-table-cell>
                             </md-table-row>
                           </md-table>
                         </div>
                       </div>
                     </md-card-content>
                   </md-card>
                 </form>
               </div>
             </div>
            </md-tab>
            <md-tab
                id="additional_info"
                md-label="Additional info"
                md-icon="info"
            >
<!--              info-->
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Additional Info</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>House rules</label>
                              <md-input v-model="additional_info.house_rules" md-placeholder="House rules"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>House manual</label>
                              <md-input v-model="additional_info.house_manual" md-placeholder="House manual"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Key pickup</label>
                              <md-input v-model="additional_info.key_pickup" md-placeholder="Key pickup"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Special instruction</label>
                              <md-input v-model="additional_info.special_instruction" md-placeholder="Special instruction"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Door code <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="right" title="Door code"></i></label>
                              <md-input v-model="additional_info.door_code" md-placeholder="Door code"></md-input>
                            </md-field>

                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Bed type</label>
                              <md-input v-model="additional_info.bed_type" md-placeholder="Bed type"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">

                            <md-table v-model="additional_info_checkbox" @md-selected="onSelectAdditional">
                              <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                  md-selectable="multiple"
                                  md-auto-select
                              >
                                <md-table-cell>{{ item.name }}</md-table-cell>
                              </md-table-row>
                            </md-table>

<!--                            -->
<!--                            <md-field>-->
<!--                              <label>Automatically generate a door code</label>-->
<!--                              <md-input v-model="additional_info.automatically_generate_a_door_cod" md-placeholder="Automatically generate a door code"></md-input>-->
<!--                            </md-field>-->
<!--                            <md-field>-->
<!--                              <label>Phone number-based code</label>-->
<!--                              <md-input v-model="additional_info.phone_number_based_code" md-placeholder="Phone number-based code"></md-input>-->
<!--                            </md-field>-->



                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Listing's cleanliness status</label>
                              <md-select v-model="additional_info.listings_cleanliness_status">
                                <md-option value="Not Set">Not Set</md-option>
                                <md-option value="Clean">Clean</md-option>
                                <md-option value="Not Clean">Not Clean</md-option>
                              </md-select>
                            </md-field>
<!--                            <md-field>-->
<!--                              <label>Listing's cleanliness status</label>-->
<!--                              <md-input v-model="additional_info.listings_cleanliness_status" md-placeholder="Listing's cleanliness status"></md-input>-->
<!--                            </md-field>-->
                            <md-field>
                              <label>Cleaning instruction</label>
                              <md-input v-model="additional_info.cleaning_instruction" md-placeholder="Cleaning instruction"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Wi-fi username</label>
                              <md-input v-model="additional_info.wi_fi_username" md-placeholder="Wi-fi username"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Wi-fi password</label>
                              <md-input v-model="additional_info.wi_fi_password" md-placeholder="Wi-fi password"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Check in Time Start</label>
                              <md-select v-model="additional_info.check_in_time_start" name="check_in_time_start" id="check_in_time_start">
                                <md-option
                                    v-for="item in times"
                                    :key="item.id"
                                    :value="item.time">
                                  {{ item.time }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Check in Time End</label>
                              <md-select v-model="additional_info.check_in_time_end" name="check_in_time_end" id="check_in_time_end">
                                <md-option
                                    v-for="item in times"
                                    :key="item.id"
                                    :value="item.time">
                                  {{ item.time }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Check out Time</label>
                              <md-select v-model="additional_info.check_out_time" name="check_out_time" id="check_out_time">
                                <md-option
                                    v-for="item in times"
                                    :key="item.id"
                                    :value="item.time">
                                  {{ item.time }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="contact_invoicing"
                md-label="Contact And Invoicing"
                md-icon="person"
            >
             <div class="md-layout">
               <div class="md-layout-item md-medium-size-100 md-size-100">
                 <div class="title">
                   <h4>Contact and Invoicing</h4>
                 </div>
                 <form>
                   <md-card>
                     <md-card-content>
                       <div class="md-layout">
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Contact person's name</label>
                             <md-input v-model="contact_invoicing.contact_name" md-placeholder="Contact person's name"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Contact person's last name</label>
                             <md-input v-model="contact_invoicing.contact_surname" md-placeholder="Contact person's last name"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Phone number</label>
                             <md-input v-model="contact_invoicing.phone_number" type="number" md-placeholder="Phone number"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Second phone number</label>
                             <md-input v-model="contact_invoicing.second_phone_number" type="number" md-placeholder="Second phone number"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Contact person's spoken language</label>
                             <md-input v-model="contact_invoicing.contact_language" md-placeholder="Contact person's spoken language"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Contact person's email</label>
                             <md-input v-model="contact_invoicing.contact_email" type="email" md-placeholder="Contact person's email"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Contact person's address</label>
                             <md-input v-model="contact_invoicing.contact_address" md-placeholder="Contact person's address"></md-input>
                           </md-field>
                         </div>
                         <div class="md-layout-item md-small-size-100 md-size-50">
                           <md-field>
                             <label>Tax ID</label>
                             <md-input v-model="contact_invoicing.tax_id" md-placeholder="Tax ID"></md-input>
                           </md-field>
                         </div>
                       </div>
                     </md-card-content>
                   </md-card>
                 </form>
               </div>
             </div>
            </md-tab>
            <md-tab id="attachment" md-label="Attachment" md-icon="upload">
              <div class="attachment_tab">
                <div class="title">
                  <h4>Attachments</h4>
                </div>
                <div class="media_main">
                  <div class="preview_container mr-1" v-if="attachments.length">
                    <div v-for="(file, index) in attachments" :key="file.name + file.size" class="preview_card">
                      <div class="preview_card-item">
                        <embed :src="file.src" type="application/pdf" width="100%" />
                        <p class="py-2">{{ file.name }} - {{ Math.round(file.size / 1000) }} KB</p>
                        <div class="preview_card_input-item md-layout-item md-small-size-100 md-size-100">
                          <input
                              v-model="file.attachments_is_public"
                              :true-value="1"
                              :false-value="0"
                              type="checkbox"
                          />
                          <label class="p-2">Attachments is public</label>
                        </div>
                      </div>
                      <button
                          class="preview_card-close ml-2"
                          type="button"
                          @click="removeAttach(index)"
                          title="Remove file"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                  <div
                      class="dropzone_container"
                      @dragover="dragoverAttach"
                      @dragleave="dragleaveAttach"
                      @drop="dropAttach"
                      :style="isDraggingAttach && 'border-color: green;'"
                  >
                    <input
                        type="file"
                        multiple
                        name="attachments"
                        id="attachmentsInput"
                        class="dropzone_input"
                        @change="onChangeAttach"
                        ref="fileAttach"
                        accept=".pdf"
                    />
                    <label for="attachmentsInput" class="dropzone_label">
                      <div v-if="isDraggingAttach">Release to drop files here.</div>
                      <div v-else>Drop files here or <u>click here</u> to upload.</div>
                    </label>
                  </div>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="booking"
                md-label="Booking settings"
                md-icon="event"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Booking settings</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Minimum nights</label>
                              <md-input
                                  v-model="booking_settings.minimum_nights"
                                  type="number"
                                  min="1"
                                  step="1"
                                  @input="clampNumber('minimum_nights', 1)"
                                  @keydown="preventInvalidKeys($event)"
                                  md-placeholder="Minimum nights"
                              ></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Maximum nights</label>
                              <md-input
                                  v-model="booking_settings.maximum_nights"
                                  type="number"
                                  :min="Math.max(1, booking_settings.minimum_nights || 1)"
                                  @input="clampNumber('maximum_nights', booking_settings.minimum_nights || 1)"
                                  @keydown="preventInvalidKeys($event)"
                                  md-placeholder="Maximum nights"
                              ></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <div class="pt-3">
                              <input
                                  v-model="booking_settings.enable_reservations_for_gap_nights"
                                  :true-value="1"
                                  :false-value="0"
                                  type="checkbox" />
                              <label class="mx-2">Gap nights*</label>
                            </div>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Smallest allowed gap</label>
                              <md-input v-model="booking_settings.smallest_allowed_gap" type="number" md-placeholder="Smallest allowed gap" @input="clampNumber('smallest_allowed_gap', 1)"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Allow gaps between start</label>
                              <md-input v-model="booking_settings.allow_gaps_between_start" type="number" md-placeholder="Allow gaps between start" @input="clampNumber('allow_gaps_between_start', 1)"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Allow gaps between end</label>
                              <md-input v-model="booking_settings.allow_gaps_between_end" type="number" md-placeholder="Allow gaps between end" @input="clampNumber('allow_gaps_between_end', 1)"></md-input>
                            </md-field>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="bad_types"
                md-label="Bed types"
                md-icon="bed"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Bed Types</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Bed Type*</label>
                              <md-select v-model="newRoom.bed_type_id" name="bed_type" id="bed_type">
                                <md-option
                                    v-for="item in allBedTypes"
                                    :key="item.id"
                                    :value="item.id">
                                  {{ item.name }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Room Number*</label>
                              <md-input v-model="newRoom.room_number" md-placeholder="Room Number"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Quantity*</label>
                              <md-input v-model="newRoom.quantity" md-placeholder="Quantity"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50 text-right">
                            <md-button class="md-raised md-success" @click="addBed()">Add </md-button>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <md-card id="bad_types_table">
                      <md-card-header data-background-color="green">
                        <h4 class="title">Rooms</h4>
                        <!-- <p class="category">Here is a subtitle for this table</p> -->
                      </md-card-header>
                      <md-card-content>
                        <md-table v-model="rooms" table-header-color="green">
                          <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="Bed type">{{ getBedTypeName(item.bed_type_id) }}</md-table-cell>
                            <md-table-cell md-label="Room number">{{ item.room_number }}</md-table-cell>
                            <md-table-cell md-label="Quantity">{{ item.quantity }}</md-table-cell>
                            <md-table-cell md-label="">
                              <span class="cursor_pointer" @click="deleteBed(item)">
                                <md-icon>delete</md-icon>
                              </span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
              </div>
            </md-tab>
          </md-tabs>
        </template>
      </nav-tabs-card>
    </div>
  </div>
</template>

<script>
import Maps from "@/pages/Maps.vue";
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable,
} from "@/components";
import {mapActions} from "vuex";
export default {
  name: "CreateListing",
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable,
    Maps,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  props: {
    dataBackgroundColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showErrors: false,
      errors: [],
      currencySearch: "",
      dropdownOpen: false,
      isTagsOpen: false,
      listingSettings: [],
      allCountries: [],
      personCapacities: [],
      tagOptions: [],
      propertyTypes: [],
      roomTypes: [],
      numberOfBedrooms: [],
      numberOfBeds: [],
      numberOfBathrooms: [],
      bathroomTypes: [],
      numberOfGuestBathrooms: [],
      allBedTypes: [],
      times: [],
      setAddress: '',
      lat: null,
      lng: null,
      debounceTimer: null,

      basic_info: {
        external_listing_name: '',
        person_capacity: '',
        tags_ids: [],
        property_type_id: '',
        description: '',
        room_type_id: '',
        number_of_bathrooms: '',
        number_of_beds: '',
        number_of_bedrooms: '',
        bathroom_type_id: '',
        number_of_guest_bathrooms: ''
      },
      address: {
        address: '',
        public_address: '',
        country: '',
        state: '',
        city: '',
        street: '',
        zip_code: '',
        latitude: '',
        longitude: '',
      },
      price_and_fees: {
        currency_code: '',
        price: '',
        price_fo_extra_person: '',
        guests_included: '',
        refundable_damage_deposit: '',
        cleaning_fee: '',
        weekly_discount: '',
        monthly_discount: '',
      },
      additional_info_checkbox: [
        {
          name: 'Automatically generate a door code',
          automatically_generate_a_door_cod: 1,
        },
        {
          name: 'Phone number-based code (If supported by lock)',
          phone_number_based_code: 1,
        }
      ],
      additional_info: {
        house_rules: '',
        house_manual: '',
        cleaning_instruction: '',
        key_pickup: '',
        special_instruction: '',
        door_code: '',
        bed_type: '',
        wi_fi_username: '',
        wi_fi_password: '',
        listings_cleanliness_status: '',
        check_in_time_start: '',
        check_in_time_end: '',
        check_out_time: '',
      },
      contact_invoicing: {
        contact_name: '',
        contact_surname: '',
        phone_number: '',
        second_phone_number: '',
        contact_language: '',
        contact_email: '',
        contact_address: '',
        tax_id: ''
      },
      booking_settings: {
        minimum_nights: 1,
        maximum_nights: 1,
        enable_reservations_for_gap_nights: 0,
        smallest_allowed_gap: 1,
        allow_gaps_between_start: 1,
        allow_gaps_between_end: 1,
      },
      rooms: [],
      newRoom: {
        bed_type_id: null,
        room_number: null,
        quantity: null
      },
      isDragging: false,
      isDraggingAttach: false,
      files: [],
      exclude_from_reservation: [
        {
          name: 'Exclude from reservation sum',
          exclude_from_reservation_sum: 1
        }
      ],
      additional_info_checked: [],
      selected_reservation: [],
      amenities: [],
      selectedAmenities: [],
      selected_amenities: [],
      attachments: []
    };
  },
  computed: {
    currencyOptions() {
      const seen = new Set();

      return this.allCountries
          .filter(c => c.currencies && c.currencies[0])
          .map(c => ({
            code: c.currencies[0].code,
            name: c.name
          }))
          .filter(option => {
            if (seen.has(option.code)) return false;
            seen.add(option.code);
            return true;
          });
    },
    hasBasicInfoErrors() {
      if (!this.showErrors) return false;
      return !this.basic_info.external_listing_name;
    },

    basicInfoErrorCount() {
      return !this.basic_info.external_listing_name ? 1 : 0;
    },

    hasAnyErrors() {
      return this.hasBasicInfoErrors;
    },

    totalErrorCount() {
      return this.basicInfoErrorCount;
    },
    // Get selected tag names for display
    selectedTagNames() {
      return this.basic_info.tags_ids.map(tagId => this.getTagName(tagId));
    },
  },
  mounted() {
    this.getListingSettings()
      .then(res => {
        this.listingSettings = res.data.data

        this.personCapacities = res.data.data.person_capacities
        this.propertyTypes = res.data.data.property_types
        this.roomTypes = res.data.data.room_types
        this.numberOfBedrooms = res.data.data.number_of_bedrooms
        this.numberOfBeds = res.data.data.number_of_beds
        this.numberOfBathrooms = res.data.data.number_of_bathrooms
        this.bathroomTypes = res.data.data.bathroom_types
        this.numberOfGuestBathrooms = res.data.data.number_of_guest_bathrooms
        this.times = res.data.data.times
        
        this.allBedTypes = res.data.data.bed_types
        this.allCountries = res.data.data.countries
        this.tagOptions = res.data.data.tags
        this.$nextTick(() => {
            if (!Array.isArray(this.basic_info.tags_ids)) this.basic_info.tags_ids = [];
          });
        this.amenities = res.data.data.amenities.map(amenity => ({
              id: amenity.id,
              name: amenity.name,
              key: this.generateAmenityKey(amenity.name),
              checked: false
            }))
      })
      .catch(err => {
        console.error('Error loading listing settings:', err)
      })


 
    // this.getListAmenities()
    //     .then(res => {
    //       // Преобразуем данные из API в нужный формат
    //       if (res && res.data && res.data.data) {
    //         this.amenities = res.data.data.map(amenity => ({
    //           id: amenity.id,
    //           name: amenity.name,
    //           key: this.generateAmenityKey(amenity.name),
    //           checked: false
    //         }))
    //       }
    //     })
    //     .catch(err => {
    //       console.error('Error loading amenities:', err)
    //     })
  },
  methods: {
    ...mapActions([
      'getListingSettings',
      'getListAmenities',
      'createListing',
    ]),
    // Check if tags are selected
    hasSelectedTags() {
      return this.basic_info.tags_ids && this.basic_info.tags_ids.length > 0;
    },
    selectCurrency(code) {
      this.price_and_fees.currency_code = code;
      this.currencySearch = code; // show in input
      this.dropdownOpen = false;
    },
    getTabErrorMessage(tabName) {
      if (tabName === 'basic-info') {
        return 'External listing name is required';
      }
      return '';
    },
    closeDropdown() {
      // small delay so click registers before hiding
      setTimeout(() => {
        this.dropdownOpen = false;
      }, 200);
    },
    getBedTypeName(id) {
      const type = this.allBedTypes.find(b => b.id === id);
      return type ? type.name : 'Unknown';
    },
    saveData(draft_status) {

      this.showErrors = true;
      if (!this.basic_info.external_listing_name) {
        if (this.$refs.tabs) {
          this.$refs.tabs.setActiveTab('tab-home');
        }
        return false;
      }
      this.showErrors = false;

      // Отправляем данные
      {
          let all_images = []
          let all_image_sequences = []
            if(this.files.length) {
              for (const [key, value] of Object.entries(this.files))  {
                all_images.push(value)
                all_image_sequences.push(Number(value.image_sequences))
              }
            }
          let attachments = []
          let attachments_file_name = []
          let attachments_is_public = []
          let selectedAmenity = this.getSelectedAmenities()
          if(this.attachments.length) {
            for (const [key, value] of Object.entries(this.attachments))  {
              attachments.push(value)
              attachments_file_name.push(value.name)
              attachments_is_public.push(value.attachments_is_public == 1 ? 1 : 0)
            }
          }
          let sendData = {
            draft: draft_status,
            basic_info: this.basic_info,
            address: this.address,
            selected_amenities: selectedAmenity,
            price_and_fees: this.price_and_fees,
            additional_info: this.additional_info,
            additional_info_checked: this.additional_info_checked,
            contact_invoicing: this.contact_invoicing,
            booking_settings: this.booking_settings,
            rooms: this.rooms,
            images: all_images,
            image_sequences: all_image_sequences,
            attachments: attachments,
            attachments_file_name: attachments_file_name,
            attachments_is_public: attachments_is_public
          }
          this.createListing(sendData)
            .then(res => {
              if(res.response) {
                this.errors = res.response.data.errors
                // Прокручиваем к ошибкам
                this.$nextTick(() => {
                  const errorElement = document.querySelector('.text-danger');
                  if (errorElement) {
                    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }
                });
              } else {
                // Очищаем форму после успешного создания
                this.resetForm();
                this.$router.push('/admin/listings')
              }
            })
            .catch(err => {
              console.error('Error creating listing:', err);
              this.errors = { general: ['Произошла ошибка при создании объявления. Пожалуйста, попробуйте снова.'] };
            })
          return true;
      }
    },
    async  onChange() {
      const self = this;
      let incomingFiles = Array.from(this.$refs.file.files);
      let validFiles = [];

      // Prevent duplicate uploads (same name + size)
      const fileExist = self.files.some((r) =>
          incomingFiles.some(
              (file) => file.name === r.name && file.size === r.size
          )
      );

      if (fileExist) {
        alert("New upload contains files that already exist.");
        return;
      }

      for (const file of incomingFiles) {
        const isValid = await self.validateImage(file);
        if (isValid) {
          // Add custom caption + sequence placeholders
          file.image_sequences = self.files.length + validFiles.length + 1;
          file.vrbo_caption = "";
          file.engine_caption = "";
          validFiles.push(file);
        }
      }

      if (validFiles.length) {
        self.files.push(...validFiles);
      }
      self.$refs.file.value = "";
    },
    async validateImage(file) {
      const maxMB = 2;
      const minWidth = 1024;
      const minHeight = 683;

      if (!["image/jpeg", "image/png"].includes(file.type)) {
        alert(`${file.name}: Only JPG and PNG formats are allowed.`);
        return false;
      }

      if (file.size > maxMB * 1024 * 1024) {
        alert(`${file.name}: File exceeds ${maxMB} MB.`);
        return false;
      }

      const hasValidDimensions = await this.checkImageDimensions(file, minWidth, minHeight);
      if (!hasValidDimensions) {
        alert(`${file.name}: Minimum size is ${minWidth}x${minHeight}px.`);
        return false;
      }

      return true;
    },

    checkImageDimensions(file, minWidth, minHeight) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          resolve(img.width >= minWidth && img.height >= minHeight);
        };
        img.onerror = () => resolve(false);
        img.src = URL.createObjectURL(file);
      });
    },
    onChangeAttach() {
      const incomingFiles = Array.from(this.$refs.fileAttach.files);
      const newFiles = incomingFiles.filter((file) => {
        return !this.attachments.some(
            (existing) =>
                existing.name === file.name && existing.size === file.size
        );
      });
      if (newFiles.length !== incomingFiles.length) {
        alert("Some uploaded files already exist.");
      }
      newFiles.forEach((file) => {
        file.src = URL.createObjectURL(file);
      });
      this.attachments.push(...newFiles);
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragoverAttach(e) {
      e.preventDefault();
      this.isDraggingAttach = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    dragleaveAttach() {
      this.isDraggingAttach = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    dropAttach(e) {
      e.preventDefault();
      this.$refs.fileAttach.files = e.dataTransfer.files;
      this.onChangeAttach();
      this.isDraggingAttach = false;
    },
    remove(i) {
      // Очищаем URL объекта перед удалением
      if (this.files[i] && this.files[i].url) {
        URL.revokeObjectURL(this.files[i].url);
      }
      this.files.splice(i, 1);
    },
    removeAttach(i) {
      this.attachments.splice(i, 1);
    },
    getSelectedAmenities() {
      // Возвращаем массив объектов с id для отправки в API
      // Store ожидает: [{id: 1}, {id: 2}]
      return this.amenities
        .filter(a => a.checked)
        .map(a => ({ id: a.id }));
    },
    generateAmenityKey(name) {
      // Преобразуем название в snake_case ключ
      // Обрабатываем сокращения типа "WiFi" -> "wi_fi"
      let key = name
          .replace(/([a-z])([A-Z])/g, '$1_$2') // Добавляем подчеркивание перед заглавными буквами
          .toLowerCase()
          .replace(/\s+/g, '_')
          .replace(/[^a-z0-9_]/g, '')
          .replace(/_+/g, '_') // Убираем множественные подчеркивания
          .replace(/^_|_$/g, ''); // Убираем подчеркивания в начале и конце
      
      return key;
    },
    generateURL(file) {
      // Создаем URL для отображения файла
      // Не очищаем URL сразу, так как он нужен для отображения
      // Очистка будет выполнена при удалении компонента или файла
      if (file.url) {
        return file.url;
      }
      file.url = URL.createObjectURL(file);
      return file.url;
    },
    onSelect: function (items) {
      // Проверяем, что items является массивом
      if (Array.isArray(items)) {
        this.selected_amenities = items.map(item => {
          const { name, ...valuesOnly } = item;
          return valuesOnly;
        });
      } else {
        this.selected_amenities = [];
      }
    },
    onSelectReservation:function (items) {
      this.selected_reservation = items;
    },
    onSelectAdditional:function (items) {
      this.additional_info_checked = items.map(item => {
        const { name, ...valuesOnly } = item;
        return valuesOnly;
      });
    },
    onTagSelected(selectedTag) {
      this.basic_info.tags_ids.push(selectedTag)
    },
    // Handle when tags dropdown opens
    onTagsOpened() {
      this.isTagsOpen = true;
    },
    // Handle when tags dropdown closes
    onTagsClosed() {
      this.isTagsOpen = false;
    },
    // Remove a specific tag
    removeTag(tagId) {
      const index = this.basic_info.tags_ids.indexOf(tagId);
      if (index > -1) {
        this.basic_info.tags_ids.splice(index, 1);
      }
    },

    // Get tag name by ID for display
    getTagName(tagId) {
      const tag = this.tagOptions.find(tag => tag.id === tagId);
      return tag ? tag.name : 'Unknown Tag';
    },

    // Clear all selected tags
    clearAllTags() {
      this.basic_info.tags_ids = [];
    },
    addBed() {
      if (!this.newRoom.bed_type_id || !this.newRoom.room_number || !this.newRoom.quantity) return;
      this.rooms.push({
        bed_type_id: this.newRoom.bed_type_id,
        room_number: this.newRoom.room_number,
        quantity: this.newRoom.quantity
      })
      this.newRoom = {
        bed_type_id: null,
        room_number: null,
        quantity: null
      };
    },
    deleteBed(item) {
      // Используем более точный поиск по всем полям для избежания удаления неверной записи
      const index = this.rooms.findIndex(room => 
        room.bed_type_id === item.bed_type_id && 
        room.room_number === item.room_number && 
        room.quantity === item.quantity
      );
      if (index > -1) {
        this.rooms.splice(index, 1);
      }
    },
    checkMap() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        let address_line = {
          address: this.address.address,
          city: this.address.city,
          country: this.address.country,
          state: this.address.state
        }
        this.setAddress = address_line.address + ' ' + address_line.city + ' ' + address_line.state + ' ' + address_line.country
        this.geocodeAddress();
      }, 800);
    },
    async geocodeAddress() {
      if (!this.setAddress || this.setAddress.trim() === '') {
        alert('Please enter an address');
        return;
      }
      // const mapboxToken = 'pk.eyJ1IjoibWluZ3lhbjIxNCIsImEiOiJja2h4Y2xiajAwMTBsMnZuNHBzMjVmYjlsIn0.w7Wxvvi2i4olHVL2gE1zkQ';
      const encoded = encodeURIComponent(this.setAddress);
      // const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encoded}.json?access_token=${mapboxToken}`;
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encoded}`;

      try {
        const res = await fetch(url, {
          headers: {
            'User-Agent': 'STRWeb/1.0 (your-email@example.com)' // Nominatim requires a user agent
          }
        });
        const data = await res.json();
        if (data && data.length > 0) {
          this.lat = parseFloat(data[0].lat);
          this.lng = parseFloat(data[0].lon);
          // Сохраняем координаты в объект address для отправки на сервер
          this.address.latitude = this.lat;
          this.address.longitude = this.lng;

          this.$nextTick(() => {
            console.log('Coordinates set:', this.lat, this.lng);
          });
        } else {
          // alert('Address not found or no results returned.');
          this.lat = null;
          this.lng = null;
        }
      } catch (err) {
        console.error("Geocoding error:", err);
        alert('An error occurred while geocoding the address.');
        this.lat = null; // Clear previous coordinates on error
        this.lng = null;
      }
    },
    clampNumber(field, minAllowed = 1) {
      let val = Number(this.booking_settings[field]);

      if (!Number.isFinite(val)) {
        // allow empty while typing
        if (this.booking_settings[field] === '' || this.booking_settings[field] === null || this.booking_settings[field] === undefined) {
          return;
        }
        val = minAllowed;
      }

      val = Math.floor(val);
      if (val < minAllowed) val = minAllowed;

      if (field === 'maximum_nights' && Number.isFinite(Number(this.booking_settings.minimum_nights))) {
        const minFromMinNights = Math.max(minAllowed, Number(this.booking_settings.minimum_nights));
        if (val < minFromMinNights) val = minFromMinNights;
      }

      this.booking_settings[field] = val;
    },

    preventInvalidKeys(e) {
      const invalid = ['e', 'E', '+', '-', ','];

      // allow control/navigation keys
      const controlKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        'Tab', 'Home', 'End'
      ];

      if (controlKeys.includes(e.key)) return;

      // block invalid characters
      if (invalid.includes(e.key)) {
        e.preventDefault();
      }
    },
    resetForm() {
      // Очищаем все URL объектов перед сбросом
      this.files.forEach(file => {
        if (file.url) {
          URL.revokeObjectURL(file.url);
        }
      });
      this.attachments.forEach(attach => {
        if (attach.src) {
          URL.revokeObjectURL(attach.src);
        }
      });
      
      // Сброс всех данных формы
      this.basic_info = {
        external_listing_name: '',
        person_capacity: '',
        tags_ids: [],
        property_type_id: '',
        description: '',
        room_type_id: '',
        number_of_bathrooms: '',
        number_of_beds: '',
        number_of_bedrooms: '',
        bathroom_type_id: '',
        number_of_guest_bathrooms: ''
      };
      this.address = {
        address: '',
        public_address: '',
        country: '',
        state: '',
        city: '',
        street: '',
        zip_code: '',
        latitude: null,
        longitude: null,
      };
      this.price_and_fees = {
        currency_code: '',
        price: '',
        price_fo_extra_person: '',
        guests_included: '',
        refundable_damage_deposit: '',
        cleaning_fee: '',
        weekly_discount: '',
        monthly_discount: '',
      };
      this.additional_info = {
        house_rules: '',
        house_manual: '',
        cleaning_instruction: '',
        key_pickup: '',
        special_instruction: '',
        door_code: '',
        bed_type: '',
        wi_fi_username: '',
        wi_fi_password: '',
        listings_cleanliness_status: '',
        check_in_time_start: '',
        check_in_time_end: '',
        check_out_time: '',
      };
      this.contact_invoicing = {
        contact_name: '',
        contact_surname: '',
        phone_number: '',
        second_phone_number: '',
        contact_language: '',
        contact_email: '',
        contact_address: '',
        tax_id: ''
      };
      this.booking_settings = {
        minimum_nights: '',
        maximum_nights: '',
        enable_reservations_for_gap_nights: 0,
        smallest_allowed_gap: '',
        allow_gaps_between_start: '',
        allow_gaps_between_end: '',
      };
      this.rooms = [];
      this.newRoom = {
        bed_type_id: null,
        room_number: null,
        quantity: null
      };
      this.files = [];
      this.attachments = [];
      this.additional_info_checked = [];
      this.selected_reservation = [];
      this.amenities.forEach(amenity => {
        amenity.checked = false;
      });
      this.lat = null;
      this.lng = null;
      this.setAddress = '';
      this.showErrors = false;
      this.errors = [];
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .currency_code {
  width: 100%;
  border: none !important;
  & .vs__dropdown-toggle {
    border: none !important;
  }
}

.media, .attachment {
  &_tab {
    min-height: 50vh;
    & .dropzone {
      &_container {
        padding: 20px;
        background: #f7fafc;
        border: 2px dashed #9e9e9e;
        width: 400px;
        height: 100px;
      }
      &_input {
        opacity: 0;
        overflow: hidden;
        position: absolute;
        width: 1px;
        height: 1px;
      }
      &_label {
        font-size: 18px;
        display: block;
        cursor: pointer;
        text-align: center;
      }
    }
  }
  &_main {
    display: flex;
    margin-top: 10px;
    & .preview {
      &_container {
        display: flex;
        flex-wrap: wrap;
        & .md-field {
          padding-top: 8px;
          margin-bottom: 0;
          min-height: 45px;
        }
      }
      &_card {
        display: flex;
        border: 1px solid #a2a2a2;
        border-radius: 5px;
        padding: 12px;
        margin-right: 20px;
        margin-bottom: 20px;
        width: 370px;
        height: 420px;
        position: relative;
        &-item {
          width: 100%;
          & embed {
            height: 75%;
          }
        }
        &_input {
          &-item {
            padding: 5px 0;
          }
        }
        &-close {
          position: absolute;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid lightgray;
          top: 5px;
          right: 5px;
        }
      }
      &_img {
        width: 100%;
        height: 200px;
        border-radius: 5px;
        border: 1px solid #a2a2a2;
        background-color: #a2a2a2;
      }
    }

  }
}

.md-ripple span {
  position: unset;
}
::v-deep #bad_types_table table thead {
  display: table-header-group !important;
}

/* if you want the active one to be stronger */
.md-tab.has-error.md-active {
  background-color: #f44336 !important; /* material red */
  color: #fff !important;
}
.error-chip {
  margin-left: 10px;
}
.title h4 {
  display: flex;
  align-items: center;
}
.md-tabs .md-tab.has-error {
  background-color: #ffebee !important; /* Light red background */
  border-left: 4px solid #f44336 !important; /* Red border indicator */
}

.md-tabs .md-tab.has-error .md-tab-label {
  color: #f44336 !important; /* Red text color */
  font-weight: 600 !important; /* Bold text */
}

.md-tabs .md-tab.has-error .md-icon {
  color: #f44336 !important; /* Red icon color */
}

/* Option 2: Red outline/border styling */
.md-tabs .md-tab.has-error-outline {
  border: 2px solid #f44336 !important;
  border-radius: 4px !important;
  margin: 2px !important;
}

.md-tabs .md-tab.has-error-outline .md-tab-label {
  color: #f44336 !important;
}

/* Option 3: Subtle warning with yellow/orange */
.md-tabs .md-tab.has-warning {
  background-color: #fff3e0 !important; /* Light orange */
  border-left: 4px solid #ff9800 !important; /* Orange border */
}

.md-tabs .md-tab.has-warning .md-tab-label {
  color: #ff9800 !important;
}

/* Option 4: Pulsing animation for critical errors */
.md-tabs .md-tab.has-error-critical {
  background-color: #ffebee !important;
  animation: pulse-error 2s infinite !important;
}

@keyframes pulse-error {
  0% { box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.7); }
  70% { box-shadow: 0 0 0 10px rgba(244, 67, 54, 0); }
  100% { box-shadow: 0 0 0 0 rgba(244, 67, 54, 0); }
}

/* Active state overrides for error tabs */
.md-tabs .md-tab.has-error.md-active {
  background-color: #f44336 !important;
}

.md-tabs .md-tab.has-error.md-active .md-tab-label,
.md-tabs .md-tab.has-error.md-active .md-icon {
  color: white !important;
}
</style>
